import { types } from "mobx-state-tree";
/**
 * This model represents a generic object within a CLUE tile.
 */
export const ClueObjectModel = types
    .model("ClueObjectModel", {
    tileId: types.string,
    objectId: types.string,
    objectType: types.maybe(types.string)
});
/**
 * A simple model to represent a 2d offset
 */
export const OffsetModel = types
    .model("OffsetModel", {
    dx: types.optional(types.number, 0),
    dy: types.optional(types.number, 0)
})
    .actions(self => ({
    setDx(dx) {
        self.dx = dx;
    },
    setDy(dy) {
        self.dy = dy;
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2x1ZS1vYmplY3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbW9kZWxzL2Fubm90YXRpb25zL2NsdWUtb2JqZWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBd0IsS0FBSyxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFOUQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsS0FBSztLQUNuQyxLQUFLLENBQUMsaUJBQWlCLEVBQUU7SUFDeEIsTUFBTSxFQUFFLEtBQUssQ0FBQyxNQUFNO0lBQ3BCLFFBQVEsRUFBRSxLQUFLLENBQUMsTUFBTTtJQUN0QixVQUFVLEVBQUUsS0FBSyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDO0NBQ3RDLENBQUMsQ0FBQztBQU1IOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLEtBQUs7S0FDL0IsS0FBSyxDQUFDLGFBQWEsRUFBRTtJQUNwQixFQUFFLEVBQUUsS0FBSyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUMsQ0FBQztJQUNuQyxFQUFFLEVBQUUsS0FBSyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUMsQ0FBQztDQUNwQyxDQUFDO0tBQ0QsT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUNoQixLQUFLLENBQUMsRUFBVTtRQUNkLElBQUksQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDO0lBQ2YsQ0FBQztJQUNELEtBQUssQ0FBQyxFQUFVO1FBQ2QsSUFBSSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUM7SUFDZixDQUFDO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==